import { render, staticRenderFns } from "./SelectDeclineType.vue?vue&type=template&id=80bf81d6&"
import script from "./SelectDeclineType.vue?vue&type=script&lang=js&"
export * from "./SelectDeclineType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports